import { useState } from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import classes from './MetadataInfo.module.css';

const MetadataInfo = props => {
  const [value, setValue] = useState(props.metadata.preloadData);

  const changeInputHanlder = event => {
    setValue(event.target.value);
    setTimeout(() => {
      props.newMetadataHandler(
        props.metadata.tag,
        event.target.value
      );
    }, 800);
  };

  return (
    <>
      {!props.edit ? (
        <p className={classes.item}>
          <span className={classes.name}>
            {props.metadata.name}:
          </span>
          <span className={classes.info}>{value}</span>
        </p>
      ) : (
        <>
          {props.metadata.has_options ? (
            <TextField
              required
              select
              variant="outlined"
              label={props.metadata.name}
              className={classes.input}
              value={value}
              onChange={changeInputHanlder}
            >
              {props.metadata.options.map(option => {
                return (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                );
              })}
            </TextField>
          ) : (
            <TextField
              required
              variant="outlined"
              label={props.metadata.name}
              className={classes.input}
              value={value}
              onChange={changeInputHanlder}
            />
          )}
        </>
      )}
    </>
  );
};

MetadataInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  metadata: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  edit: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  newMetadataHandler: PropTypes.func
};

export default MetadataInfo;
